import Filters from '@/utils/input/filters';
import { registerModuleFilters } from '@/utils/input/filters';

const GroupFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'dynamicEntityGroupId',
  label: 'global.text.group',
  apiRoute: 'dynamicEntityGroup/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
};

export const filtersConfig = [
  GroupFilter,
  Filters.IsActiveFilter,
  CreatedDateFilter,
  UpdatedDateFilter,
];

registerModuleFilters('entities', [
  GroupFilter,
  Filters.IsActiveFilter,
  CreatedDateFilter,
  UpdatedDateFilter,
]);
